// imports react
import { useEffect, useState } from "react";

//imports libraries
import * as Yup from "yup";
import { useFormik } from "formik";
import clsx from "clsx";
import { toast } from "sonner";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";

//imports components
import styles from "../styles/login.module.css";
import fundoImage from "../images/fundo.jpg";

import { urlAPI_Current } from "../config";
import { LoginBaseBoard } from "../components/LoginBaseBoard";
import { LoginDivEVOK } from "../components/LoginDivEVOK";
import { Moon, Sun } from "lucide-react";
import { SwitchMode } from "../components/SwitchMode";
import { verifyUserPaid } from "../verifyUserPaid";
import Swal from "sweetalert2";

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Formato de email incorreto")
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Email é obrigatório"),
  password: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Senha é obrigatória"),
});

const initialValues = {
  email: "",
  password: "",
};

export function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const [userData, setUserData] = useState([]);

  const navigateTo = useNavigate();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan');
  const token = searchParams.get('token'); // token que vem do link do convite

  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  const handleModeChange = (darkMode) => {
    setDarkMode(darkMode);
  };

  function updateInvitationAccess(token) {
    try{
      const invitationAccess = axios.post(`${urlAPI_Current}/updateInvitationAccess`, {
        token: token
      }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
      });
    }catch(err){
        console.log(err)
    }
  }

  async function sendCheckout(plan) {
    if(plan != 1 || plan != '1'){
      Swal.fire({
        title: "Ainda não disponível",
        text: "Em desenvolvimento",
        icon: "info"
      });
    } else {
      try {
        setIsLoading(true);
        const payPlan = plan;
        
        const responsePayment = await axios.post(
          `${urlAPI_Current}/checkoutStripe`,
          {
            payPlan: payPlan
          }, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
            }
         }
        );
        const payment_url = responsePayment.data.linkPayment;
        
        toast.success("Direcionando para uma página segura!");

        window.open(`${payment_url}`, "_blank");
      } catch (err) {
        console.log(err);
      }
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setIsLoading(true);
      console.log(values.email);
      try {
        const response = await axios.post(
          `${urlAPI_Current}/login`,
          {
            email: values.email,
            password: values.password,
          }
        );

        
        if(response.data.success == true) {
          
          localStorage.setItem("authToken", response.data.authToken);
          localStorage.setItem("idThread", response.data.user.idThread);

          if (response.data.typeUser == 2) { // se é admin
            navigateTo("/admin/dashboard"); 
          } else if (response.data.typeUser == 3) { // se é admin BI
            navigateTo("/adminBI/licenses");
          } else if (response.data.typeUser == 1) { // usuario normal
            setUserData(response.data.user);
  
            toast.success("Usuario logado com sucesso!");

            // se tiver plano na url. Já leva direto para a pagina de checkout - sem passar pela de plans
            console.log(`Plano url ${plan}`)

            const responsePaid = await verifyUserPaid();
            if(responsePaid.success == false && plan && plan == '1'){
              sendCheckout(plan);
              return;
            }

            const reportIsSent = await verifyReportIsSent();

            if(token != "") {
              try {
                updateInvitationAccess(token);
                console.log("Acesso do convite atualizado com sucesso");
              } catch (error) {
                  console.error("Erro ao atualizar acesso do convite:", error);
              }
            } else {
              console.log("Não tem token");
            }

            if(reportIsSent){ // se ja respondeu
              navigateTo("/resultQuestionary");
            } else {
              const questionsAnswered = await getQuestionsAnswered();
              if (questionsAnswered > 0) {
                navigateTo("/questionary");
              } else {
                navigateTo("/questionaryAlert");
              }
            } 
          }
        } else if(response.data.success == false) {
          toast.error(`Email ou senha inválidos`);
        }
      } catch (error) {
        console.error(`Erro ao fazer login! ${error}`);
        toast.error(`Erro ao fazer login! ${error}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  async function getQuestionsAnswered() {
    try {
      const response = await axios.post(
        `${urlAPI_Current}/getQuestionsAnswered`, {} , {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
       }
      );
      if (response.data.success == true) {
        const responseQuestions = response.data.lastAnswered;
        if (responseQuestions) {
          return responseQuestions;
        }
      } else {
        console.log("Não respondeu");
      }
    } catch (error) {
      console.log("Erro ao buscar respondidas");
    }
  }

  async function verifyReportIsSent() {
    try {
      const responseProfile = await axios.post(
        `${urlAPI_Current}/getProfile`, {} , {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
       }
      );

      const relatorioEnviado = responseProfile.data.user.relatorioEnviado;
      if (responseProfile.data.success == true) {
        if (relatorioEnviado) {
          return true;
        } else {
          return false;
        }
      } else {
        console.log("Não respondeu");
        return false;
      }
    } catch (error) {
      console.log("Erro ao buscar respondidas");
      return false;
    }
  }

  function navigateToCreate() {
    if(token){
      navigateTo(`/createUser?token=${token}`);
    } else if(plan) {
      navigateTo(`/createUser?plan=${plan}`);
    } else {
      navigateTo(`/createUser`)
    }
  }

  function navigateToTerms() {
    navigateTo("/");
  }

  function navigateToPlans() {
    navigateTo("/");
  }

  function navigateToContact() {
    navigateTo("/");
  }

  function navigateToForget() {
    navigateTo("/forgetPassword");
  }

  function navigateToChange() {
    navigateTo("/changePassword");
  }

  async function handleEmailBlur(email){
    if(email != ""){
      const responseEmail = await axios.post(`${urlAPI_Current}/verifyEmailUsed`, {
        email: email
      });
  
      if(responseEmail.data.success == false){
        toast.info("Esse email não existe. Faça o cadastro")
        navigateTo("/createUser");
      }
    }
  }

  return (
    <div className={styles.container}>
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
            <div className="d-flex flex-center flex-column flex-lg-row-fluid">
              <div className="w-sm-500px w-300px w-lg-500px p-10">
                <div className="text-center mb-11">
                  <SwitchMode onModeChange={handleModeChange}/>
                  <h1 className="text-gray-900 fw-bolder mb-3" data-bs-theme={darkMode ? ('dark') : ('light')}>
                    Entrar na Conta
                  </h1>
                </div>

                <div className="separator separator-content my-14">
                  <span className="w-125px text-gray-500 fw-semibold fs-7" data-bs-theme={darkMode ? ('dark') : ('light')}>
                    Entre com email
                  </span>
                </div>

                <form
                  className="form w-100"
                  onSubmit={formik.handleSubmit}
                  noValidate
                  id="kt_login_signin_form"
                  data-bs-theme={darkMode ? ('dark') : ('light')}
                >
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Email
                    </label>
                    <input
                      placeholder="Email"
                      {...formik.getFieldProps("email")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.email && formik.errors.email,
                        },
                        {
                          "is-valid":
                            formik.touched.email && !formik.errors.email,
                        }
                      )}
                      type="email"
                      name="email"
                      autoComplete="new-email"
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.email}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0 data-bs-theme={darkMode ? ('dark') : ('light')}">
                      Senha
                    </label>
                    <input
                      placeholder="Senha"
                      type="password"
                      autoComplete="current-password"
                      {...formik.getFieldProps("password")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.password && formik.errors.password,
                        },
                        {
                          "is-valid":
                            formik.touched.password && !formik.errors.password,
                        }
                      )}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                      onFocus={() => {
                        handleEmailBlur(formik.values.email);
                      }}
                    />
                    {formik.touched.password && formik.errors.password && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.password}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                    <p className="link-primary cursor-pointer" onClick={navigateToChange}>
                      Trocar Senha
                    </p>

                    <p className="link-primary cursor-pointer" onClick={navigateToForget}>
                      Esqueceu a senha ?
                    </p>
                  </div>
                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      id="kt_sign_in_submit"
                      className="btn btn-primary"
                      disabled={formik.isSubmitting || !formik.isValid}
                    >
                      {!isLoading && (
                        <span className="indicator-label">Entrar</span>
                      )}
                      {isLoading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Carregando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>

                <div className="text-gray-500 text-center fw-semibold fs-6">
                  Não possui conta?{" "}
                  <a onClick={navigateToCreate} className="link-primary cursor-pointer">
                    Criar
                  </a>
                </div>
              </div>
            </div>

            <LoginBaseBoard />
          </div>

           <LoginDivEVOK />
        </div>
      </div>
    </div>
  );
}
